import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-agendar-tarefa',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './agendar-tarefa.component.html',
  styleUrls: ['./agendar-tarefa.component.scss'],
})
export class AgendarTarefaComponent {
  @Input() idObra: number | null = null;
  @Input() contatoInfo?: {
    cargo: string;
    nome: string;
    email: string;
    id?: number;
  };
  @Output() loading = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<void>();
  @Output() tarefaCriada = new EventEmitter<any>();

  userId: string;
  description = '';
  data = '';
  hora = '';
  responsibleID = '';
  actionID = '';
  responsavel: any[] = [];
  tarefas: any[] = [];

  tarefaCriadaSucesso = false;
  campoObrigatorioErro = false;

  today: string = new Date().toISOString().split('T')[0];

  constructor(private fichaDaObraService: FichaDaObraService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.fichaDaObraService.responsavelSelecionado$.subscribe((responsavel) => {
      if (responsavel) {
        this.responsibleID = responsavel.id.toString();
      }
    });

    this.popularResponsavelObra();
    this.popularAcao();
  }

  criarTarefa() {
 
    this.campoObrigatorioErro = false;
    if (!this.responsibleID || !this.actionID) {
      this.campoObrigatorioErro = true;
      console.error('Erro: Campos obrigatórios não preenchidos');
      return;
    }

    if (!this.idObra) {
      console.error('Erro: ID da obra não definido');
      this.loading.emit(false);
      return;
    }

    this.loading.emit(true);
    const body = {
      ActionID: Number(this.actionID),
      FollowUp: this.formatFollowUp(this.data, this.hora),
      ResponsibleID: Number(this.responsibleID),
      Description: this.description,
      isEdited: false,
      contactID: this.contatoInfo?.id || null,
    };

    this.fichaDaObraService.novaTarefa(this.idObra, body).subscribe({
      next: (res) => {
        this.loading.emit(false);
        this.tarefaCriada.emit(res);
        this.tarefaCriadaSucesso = true;
      },
      error: (err) => {
        this.loading.emit(false);
        console.error('Erro ao criar tarefa:', err);
      },
    });
  }

  fecharSucesso() {
    this.tarefaCriadaSucesso = false;
    
    this.close.emit();
  }

  formatFollowUp(date: string, time: string): string {
    if (!date || !time) return '';
    const [yyyy, mm, dd] = date.split('-');
    let horaFormatada = time.length === 5 ? `${time}:00` : time;
    return `${dd}/${mm}/${yyyy} ${horaFormatada}`;
  }

  popularResponsavelObra(): void {
    this.fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }

  popularAcao(): void {
    this.fichaDaObraService.popularTarefaseAcoes().subscribe(
      (response) => {
        this.tarefas = response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }

  limparCampos() {
    this.description = '';
    this.data = '';
    this.hora = '';
    this.responsibleID = '';
    this.actionID = '';
    this.campoObrigatorioErro = false;
  }
}
